export const VERSION = ''
